import { Injectable } from '@angular/core';
import { FinancialApiService } from '../financial-api.service';
import { PaymentSourceSearchDto } from './payment-source-search.dto';
import { PaymentSource } from './payment-source.model';
@Injectable()
export class PaymentSourceFinancialService {
  public constructor(private _apiService: FinancialApiService) {}

  public getPaymentSource(paymentSource: string) {
    return this._apiService.get(`/financial/v2/paymentsource/${paymentSource}`);
  }
  public createPaymentSource(paymentSource: PaymentSource): Promise<string> {
    return this._apiService.post('/financial/v2/paymentsource', paymentSource);
  }
  public searchPaymentSources(paymentSourceSearchDto: PaymentSourceSearchDto) {
    return this._apiService.post('/financial/v2/paymentsource/paymentsources', paymentSourceSearchDto);
  }
  public updatePaymentSource(originalPaymentSource: string, newReferralType: PaymentSource) {
    return this._apiService.put(`/financial/v2/paymentsource/${originalPaymentSource}`, newReferralType);
  }
  public deletePaymentSource(paymentSource: string) {
    return this._apiService.delete(`/financial/v2/paymentsource/${paymentSource}`);
  }
}
